import { getComplaintFollowUpRows } from "@/utils/complaintFollowUpLabels";
import type { Language } from "@/utils/languageUtils";

interface ComplaintFollowUpSummaryProps {
  category?: string;
  damageLocation?: string;
  damageType?: string;
  engineComponent?: string;
  interiorSection?: string;
  wheelType?: string;
  language?: Language;
}

export const ComplaintFollowUpSummary = ({
  category,
  language,
  ...values
}: ComplaintFollowUpSummaryProps) => {
  const rows = getComplaintFollowUpRows(category, values, language);
  if (rows.length === 0) return null;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {rows.map((row) => (
        <div key={`${row.label}-${row.value}`}>
          <label className="text-sm font-medium text-gray-500">{row.label}</label>
          <p className="text-sm mt-1">{row.value}</p>
        </div>
      ))}
    </div>
  );
};
